/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ key: NonNullable<unknown> }} Tl_Dates_ChangedInputs */

const en_tl_dates_changed = /** @type {(inputs: Tl_Dates_ChangedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dates of ${i?.key} changed`)
};

const de_tl_dates_changed = /** @type {(inputs: Tl_Dates_ChangedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Termine von ${i?.key} geändert`)
};

/**
* | output |
* | --- |
* | "Dates of {key} changed" |
*
* @param {Tl_Dates_ChangedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_dates_changed = /** @type {((inputs: Tl_Dates_ChangedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Dates_ChangedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_dates_changed(inputs)
	return en_tl_dates_changed(inputs)
});